export default { token: '7bc6e491903064803ae77b070d383a43', debug: false }
